import React from "react";
import {
  Dialog,
  DialogContent,
  DialogClose,
} from "@/components/ui/dialog";
import { X } from "lucide-react";

interface MediaLightboxProps {
  type: "image" | "video";
  url: string;
  prompt: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MediaLightbox = ({
  type,
  url,
  prompt,
  open,
  onOpenChange,
}: MediaLightboxProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] max-h-[90vh] p-0 bg-black/95 border-none overflow-hidden">
        <DialogClose className="absolute right-4 top-4 z-50 rounded-full bg-white/10 p-2 hover:bg-white/20 transition-colors">
          <X className="h-5 w-5 text-white" />
          <span className="sr-only">Close</span>
        </DialogClose>
        
        <div className="flex items-center justify-center w-full h-full min-h-[50vh]">
          {type === "video" ? (
            <video
              src={url}
              controls
              autoPlay
              className="max-w-full max-h-[85vh] object-contain"
              playsInline
            />
          ) : (
            <img
              src={url}
              alt={prompt}
              className="max-w-full max-h-[85vh] object-contain"
            />
          )}
        </div>
        
        {prompt && (
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
            <p className="text-white text-sm line-clamp-2">{prompt}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
